import { render, staticRenderFns } from "./TransferButton.vue?vue&type=template&id=655521b0&scoped=true&"
import script from "./TransferButton.vue?vue&type=script&lang=js&"
export * from "./TransferButton.vue?vue&type=script&lang=js&"
import style0 from "./TransferButton.vue?vue&type=style&index=0&id=655521b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655521b0",
  null
  
)

export default component.exports